/* eslint-disable no-unused-vars */
'use client'
import { DarkModeIcon, LightModeIcon } from '@/assets/ icons'
import { useEffect, useState } from 'react'

declare global {
  interface Window {
    isDark: boolean
  }
}

function DarkModeButton() {
  const [isDark, setDark] = useState(true)

  useEffect(() => {
    const theme = window.localStorage.getItem('cb-theme')
    setDark(theme === 'dark')
  }, [])

  function handleDark() {
    const changingToDark = !isDark

    document.documentElement.setAttribute('data-light-mode', changingToDark ? 'false' : 'true')

    window.localStorage.setItem('cb-theme', changingToDark ? 'dark' : 'light')

    const metaThemeColor = document.querySelector('meta[name=theme-color]')
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', changingToDark ? '#080c0f' : '#F8F8F8')
    }

    window.isDark = changingToDark
    window.dispatchEvent(new CustomEvent('themeChanged', { detail: { isDark: changingToDark } }))

    setDark(changingToDark)
  }

  return (
    <div
      suppressHydrationWarning
      className="cursor-pointer flex items-center dark:flex-row-reverse text-base font-bold gap-1.5 text-TextOffPlayer md:bg-MatchCard md:py-1.5 px-2 rounded-lg"
      onClick={handleDark}
    >
      <div className="md:p-[3px] dark:bg-transparent md:bg-white rounded-md">
        {' '}
        {isDark ? <LightModeIcon /> : <DarkModeIcon />}
      </div>
      {isDark ? (
        <span className="md:block hidden">Light</span>
      ) : (
        <span className="md:block hidden">Dark</span>
      )}
    </div>
  )
}

export default DarkModeButton
